import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { message } from 'antd';

import { BlogCreateEditForm } from 'components/blog/createEdit';

import BlogBannerApi from 'api/v2/blog/banner';

const BannersCreateEdit = () => {
  let history = useHistory();
  const { id } = useParams();
  const [content, setContent] = useState({});

  const handleContent = (val, key) => {
    if (val) {
      setContent((prevState) => ({
        ...prevState,
        [key]: val,
      }));
    }
  };

  const createData = async (payload) => {
    await BlogBannerApi.create(payload);

    message.success(`Successfully created new Banner`);

    history.push({
      pathname: '/cms/reviews-and-promos/banners',
    });
  };

  const updateData = async (payload) => {
    await BlogBannerApi.update(payload);

    message.success(`Successfully updated new Banner`);

    history.push({
      pathname: '/cms/reviews-and-promos/banners',
    });
  };

  useEffect(() => {
    const fetchBanner = async () => {
      const { data } = await BlogBannerApi.getById(id);
      const bannerDetail = data.data;

      setContent(bannerDetail);
    };

    id && fetchBanner();
  }, [id]);

  return (
    <BlogCreateEditForm
      pageName="Banner"
      handleCreate={createData}
      handleUpdate={updateData}
      content={content}
      handleContent={handleContent}
    />
  );
};

export default BannersCreateEdit;
